import { render, staticRenderFns } from "./InputCopy.vue?vue&type=template&id=898dfdc8&scoped=true&"
import script from "./InputCopy.vue?vue&type=script&lang=js&"
export * from "./InputCopy.vue?vue&type=script&lang=js&"
import style0 from "./InputCopy.vue?vue&type=style&index=0&id=898dfdc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898dfdc8",
  null
  
)

export default component.exports